import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule} from "@angular/common";
import {ProductService} from "@cybfed/core/services/marketplace/product.service";
import {TranslateModule} from "@ngx-translate/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {StickerAnimations} from "@white-label/pages/admin-mode/widgets/sticker-ad/sticker-ad-dashboard.component";
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";
import {InputComponent} from "@cybfed/ui-lib/forms/text-inputs/input/input.component";

@Component({
    selector: 'app-donation-widget-youtube-link',
    templateUrl: './donation-widget-youtube-link.component.html',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        CurrencyPipe,
        InputComponent
    ],
    providers: [ProductService]
})
export class DonationWidgetYoutubeLinkComponent implements OnInit {
    @Output() nextStepE: EventEmitter<any> = new EventEmitter();

    private youtubeLink:string| undefined


    constructor() {}

    ngOnInit() {
    }

    donate() {
        if (!this.youtubeLink) {
            return
        }
        this.nextStepE.emit({youtubeLink: this.youtubeLink});
    }

    select(event: string) {
        this.youtubeLink = event

    }


}
